module.exports = __webpack_public_path__ + "img/jump-space.8ed6ee4a.svg";